<template>
  <b-badge v-if="status === StatusProductionOrderType.type.DONE"
           variant="success">Produzido
  </b-badge>
  <b-badge v-else-if="status === StatusProductionOrderType.type.REPROVED"
           variant="danger">Reprovado
  </b-badge>
  <b-badge v-else-if="status === StatusProductionOrderType.type.STOPPED_PRODUCTION"
           variant="danger">Parada
  </b-badge>
  <b-badge v-else-if="status === StatusProductionOrderType.type.BEFORE_PRODUCTION"
           variant="warning">Aguardando programação
  </b-badge>
  <b-badge v-else-if="status === StatusProductionOrderType.type.SCHEDULED"
           variant="warning">Agendada
  </b-badge>
  <b-badge v-else-if="status === StatusProductionOrderType.type.PENDING"
           variant="light">Pendente
  </b-badge>
  <b-badge v-else-if="status === StatusProductionOrderType.type.PRODUCTION"
           variant="warning">Em andamento
  </b-badge>
</template>
<script>
import StatusProductionOrderType from "@/model/types/modules/production/StatusProductionOrderType";

export default {
  name: 'ProductionStatusBadge',
  data() {
    return {
      StatusProductionOrderType,
    }
  },
  props: {
    status: {
      type: Number,
      required: true,
    }
  }
}
</script>